import React, { useState, useEffect } from "react";
import {
  faArrowLeft,
  faSave,
  faTimes,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Gallery = ({ photo, index, closeModal, albumKey, setToggleCapture }) => {
  const [description, setDescription] = useState("");
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const photos = JSON.parse(localStorage.getItem(`photos${index}`)) || [];
    if (photos[albumKey]) {
      setDescription(photos[albumKey].description || "");
    }
  }, [index, albumKey]);

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleSave = () => {
    updatePhotoDescriptionInLocalStorage(index, albumKey, description);
    setEditMode(false);
  };

  const updatePhotoDescriptionInLocalStorage = (
    index,
    albumKey,
    description
  ) => {
    const photos = JSON.parse(localStorage.getItem(`photos${index}`)) || [];
    if (photos[albumKey]) {
      photos[albumKey].description = description;
      localStorage.setItem(`photos${index}`, JSON.stringify(photos));
    }
  };

  const handleClearDescription = () => {
    const photos = JSON.parse(localStorage.getItem(`photos${index}`)) || [];
    if (photos[albumKey]) {
      photos[albumKey].description = "";
      localStorage.setItem(`photos${index}`, JSON.stringify(photos));
      setDescription("");
    }
  };

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div
        className="d-flex justify-content-center"
        style={{ position: "absolute", width: "100%" }}
      >
        <div
          className="d-flex justify-content-center"
          style={{
            marginTop: "40vh",
            width: "100%",
            flexDirection: "column",
            padding: 5,
          }}
        >
          <div className="d-flex justify-content-center">
            <button
              style={{ height: 50 }}
              className="btn btn-outline-info"
              onClick={closeModal}
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Zurück
            </button>
          </div>
          {editMode ? (
            <div
              className="d-flex justify-content-center flex-column"
              style={{ marginTop: 10, width: "100%" }}
            >
              <div className="form-floating mb-2" style={{ width: "100%" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Beschreibung"
                  value={description}
                  onChange={handleDescriptionChange}
                />
                <label>Beschreibung</label>
              </div>
              <div className="d-flex flex-column">
                <button
                  className="btn btn-outline-info mb-2"
                  onClick={handleSave}
                >
                  <FontAwesomeIcon icon={faSave} /> Sparen
                </button>
                <button
                  className="btn btn-outline-info"
                  onClick={handleClearDescription}
                >
                  <FontAwesomeIcon icon={faTimes} /> Löschen
                </button>
              </div>
            </div>
          ) : (
            <button
              className="btn btn-outline-info"
              onClick={() => setEditMode(true)}
              style={{ marginTop: 10, height: 57.5 }}
            >
              <FontAwesomeIcon icon={faEdit} /> Beschreibung
            </button>
          )}
        </div>
      </div>
      <div>
        <img src={photo.decoded_image} style={{ width: "100%" }} alt="" />
      </div>
    </div>
  );
};

export default Gallery;
